export default {
  title: 'Cláusulas',
  accept: 'Aceito as condições',
  key: 'Chave de assinatura'
}